/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createSin } from '../../factoriesAny.js';
export var sinDependencies = {
  typedDependencies,
  createSin
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/esm/entry/dependenciesAny/dependenciesSin.generated.js
// module id = null
// module chunks = 